<template>
  <dialog-base v-bind="$attrs" :value="value" @input="updateVal" size="small">
    <template #header>
      <m-text variant="heading-md-bold">Welcome to the new Opendock Scheduling Portal</m-text>
    </template>
    <template #body>
      <m-stack>
        <m-text variant="body-md-bold">
          We designed a new and improved scheduling experience for you!
        </m-text>
        <m-group class="flex-nowrap" gap="spacing-1">
          <v-icon size="20px">clock-fast</v-icon>
          <m-text variant="body-md">
            Easily book and manage your appointments with any warehouse that uses Opendock
          </m-text>
        </m-group>
        <m-group class="flex-nowrap" gap="spacing-1">
          <v-icon size="20px">text-box-check-outline</v-icon>
          <m-text variant="body-md">
            In case you were already an Opendock user, we brought all of your data over to the new
            portal
          </m-text>
        </m-group>
        <m-text variant="body-sm">
          If you need any help, reach out to us through the help icon on the top right corner.
        </m-text>
      </m-stack>
    </template>
    <template #actions>
      <primary-button test-id="get-started-btn" @click="acknowledgeNewPortal">
        Get started
      </primary-button>
    </template>
  </dialog-base>
</template>

<script>
import { DialogBase, VIcon, PrimaryButton } from '@satellite/components/v2';
import dialogMixin from '@satellite/components/v2/mixins/dialogMixin';

export default {
  mixins: [dialogMixin],
  components: { DialogBase, VIcon, PrimaryButton },
  methods: {
    acknowledgeNewPortal() {
      this.$store.dispatch('App/acknowledgeNewPortal');
      this.updateVal(false);
    }
  }
};
</script>
